import axios from "axios";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ProjectConfig } from "Global";
import { CircularProgress } from "@mui/material";

export default function RitualesEditorRedirect() {
  const { ritual_id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Obtener los detalles del ritual para saber su categoría
    axios
      .get(ProjectConfig.api_url, {
        params: {
          request: "rituales_details",
          id: ritual_id,
        },
      })
      .then((response) => {
        const rituales_category_id = response.data.rituales_category_id || 1;
        // Redirigir a la URL correcta con la categoría
        navigate(`/admin/ritos/${rituales_category_id}/edit/${ritual_id}`, { replace: true });
      })
      .catch((err) => {
        console.log(err);
        // Si hay error, redirigir a la lista de categorías
        navigate("/admin/ritos/categorias");
      });
  }, [ritual_id, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <CircularProgress />
    </div>
  );
}
